export default "__VITE_ASSET__CvmjovRh__"